import { render, staticRenderFns } from "./centerLeftIndex1.vue?vue&type=template&id=9892d730&scoped=true"
import script from "./centerLeftIndex1.vue?vue&type=script&lang=js"
export * from "./centerLeftIndex1.vue?vue&type=script&lang=js"
import style0 from "./centerLeftIndex1.vue?vue&type=style&index=0&id=9892d730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9892d730",
  null
  
)

export default component.exports